<script setup lang="ts">
  import { DatePicker, IconImage } from '@/shared/ui';
  import CalendarIcon from '@/shared/assets/icons/CalendarIcon.svg';

  defineProps<{
    date: Date | null;
    datePickerOpen: boolean;
    dateString: string | undefined;
    formatDate: (dateString: string | undefined) => string;
    setDate: (value: Date | null) => void;
    setDatePickerOpen: (value: boolean) => void;
    errorMessage?: string | null;
  }>();
</script>

<template>
  <div class="flex flex-col gap-3 p-6">
    <h3 class="text-sm font-semibold text-gray-07">
      Vigência
    </h3>
    <div class="max-w-md">
      <span class="text-sm font-medium text-gray-07 mb-2 block">Data da vigência</span>
      <button
        type="button"
        class="flex items-center gap-2 bg-white-01 px-4 py-2.5 border rounded-lg text-sm focus:outline-none"
        :class="errorMessage ? 'border-red-16 text-red-16' : 'border-gray-02 text-gray-07 focus:border-gray-07'"
        @click="setDatePickerOpen(true)"
      >
        <IconImage
          :src="CalendarIcon"
          alt="Calendário"
          class="h-4 w-4"
        />
        {{ formatDate(dateString) }}
      </button>
      <DatePicker
        :selected-date="date"
        :is-open="datePickerOpen"
        @update:selected-date="setDate"
        @update:is-open="setDatePickerOpen"
      />
      <p
        v-if="errorMessage"
        class="text-red-16 text-xs mt-1"
      >
        {{ errorMessage }}
      </p>
    </div>
  </div>
</template>
